import styled from 'styled-components';

import { colors, fontFamily } from '../../ui/variables';

const main = {
  height: {
    iphone: 48,
  },
};

export const ActionButtonStyle = styled.div`
  width: 100%;

  .button-element {
    ${fontFamily.sourceSansPro.bold}
    align-items: center;
    border-radius: 8px;
    display: block;
    font-size: 14px;
    height: ${main.height.iphone}px;
    line-height: 14px;
    overflow: hidden;
    padding: 8px 16px;
    width: 100%;

    &.icon-only,
    &.icon-text {
      .icon {
        max-width: 16px;

        svg {
          display: block;
          height: auto;
          max-width: 16px;
          width: 100%;
        }
      }
    }

    &.icon-text {
      padding: 8px 28px 8px ${main.height.iphone}px;
      position: relative;
      text-align: center;
      width: 100%;

      &.icon-right {
        padding: 8px ${main.height.iphone}px 8px 28px;

        .icon {
          left: initial;
          right: 16px;
        }
      }

      &.text-align-left {
        text-align: left;
      }

      &.text-align-center {
        text-align: center;
      }

      &.text-align-right {
        text-align: right;
      }

      .icon {
        left: 16px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    &.icon-only {
      width: ${main.height.iphone}px;
    }

    &.text-align-left {
      text-align: left;
    }

    &.text-align-center {
      text-align: center;
    }

    &.text-align-right {
      text-align: right;
    }

    &.with-transition {
      transition: background-color 300ms, border 300ms, color 300ms;

      .icon {
        svg {
          transition: fill 300ms;
        }
      }
    }

    &.default-theme {
      background-color: ${colors.softBlue};
      border: solid 1px ${colors.softBlue};
      color: ${colors.mostlyWhite};

      .icon {
        svg {
          fill: ${colors.mostlyWhite};
        }
      }
    }

    &.very-dark-theme {
      background-color: ${colors.veryDarkGrayishBlue};
      border: solid 1px ${colors.veryDarkGrayishBlue};
      color: ${colors.mostlyWhite};

      .icon {
        svg {
          fill: ${colors.mostlyWhite};
        }
      }
    }

    &.light-theme {
      background-color: ${colors.veryPaleBlue};
      border: solid 1px ${colors.veryPaleBlue};
      color: ${colors.veryDarkGrayishBlue};

      .icon {
        svg {
          fill: ${colors.veryDarkGrayishBlue};
        }
      }
    }

    &.light-disabled-theme {
      background-color: transparent;
      border: solid 1px ${colors.grayishBlue};
      color: ${colors.grayishBlue};
    }

    &.disabled-theme {
      background-color: ${colors.grayishBlue};
      color: ${colors.mostlyWhite};
    }

    .text {
      white-space: nowrap;
    }
  }
`;
